<template>

    <body>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a class="navbar-brand" href="#">{{appShortName}}</a>
        </nav>
        <div class="container" style="min-height: 653px;">
            <div class="col">
                <label class="p-1 mb-0">Assinar:</label>
                <div class="row">
                    <div class="col text-center text-md-left">
                        <button @click="signWithCertificatePublic(request.arquivo, $route.params.id)"
                            class="btn btn-app ml-0 bg-warning"><i class="fa fa-certificate"></i> Com
                            Certificado</button>
                        <button @click="signWithoutCertificate(request.arquivo, $route.params.id)"
                            class="btn btn-app bg-secondary"><i class="fa fa-pencil"></i>
                            Sem Certificado</button>
                        <button @click="denyFile(request.arquivo, $route.params.id)" class="btn btn-app bg-danger"><i
                                class="fa fa-thumbs-down"></i> Recusar</button>
                    </div>
                </div>
                <h4 class="rounded p-2"><i class="fa fa-file-pdf-o"></i> Analisar documento:
                    <strong>{{request.arquivo.arquivo_nome}}.{{request.arquivo.arquivo_extensao}} </strong>
                    <router-link target="_blank" :to="`/validador?arquivo=${request.arquivo.id}`"
                        class="float-right text-lg"><u>Ver
                            assinaturas</u></router-link>
                </h4>
                <!-- /.panel-heading -->
                <div class="" id="panelListaAssinaturas">
                    <iframe type="application/pdf" id="fileStream" :src="fileStream" width="100%" height="800px"
                        name="fileStream"></iframe>
                </div>
                <label class="p-1 mb-0">Assinar:</label>
                <div class="row">
                    <div class="col text-center text-md-left">
                        <button @click="signWithCertificatePublic(request.arquivo, $route.params.id)"
                            class="btn btn-app ml-0 bg-warning"><i class="fa fa-certificate"></i> Com
                            Certificado</button>
                        <button @click="signWithoutCertificate(request.arquivo, $route.params.id)"
                            class="btn btn-app bg-secondary"><i class="fa fa-pencil"></i>
                            Sem Certificado</button>
                        <button @click="denyFile(request.arquivo, $route.params.id)" class="btn btn-app bg-danger"><i
                                class="fa fa-thumbs-down"></i> Recusar</button>
                    </div>
                </div>
            </div>
        </div>
        <m-assinar :requireDocument="request.required_document" :tokenTipo="tokenTipo" ref="ModalAssinar">
        </m-assinar>
        <m-certificate v-if="signatureCertificate" :requireDocument="request.required_document" :tokenTipo="tokenTipo"
            ref="ModalCertificate">
        </m-certificate>
        <m-recusa :requireDocument="request.required_document" :tokenTipo="tokenTipo" ref="ModalRecusa"></m-recusa>
        <m-loading ref="ModalLoading"></m-loading>
        <footer>
            <div class="main-footer clearfix" style="margin-left:0px">
                <div class="hidden-xs">
                    <b>{{appName}} versão 2.0</b>
                </div>
            </div>
        </footer>
    </body>
</template>
<script>
    import mAssinar from '../../components/file-signature/m-assinar-public.vue';
    import MCertificate from '../../components/file-signature/m-certificate-public.vue';
    import MLoading from '../../components/m-loading.vue';
    import MRecusa from '../../components/file-signature/m-recusa-public.vue';
    import fileOperations from '../dashboard/functions/fileOperations';
    export default {
        components: {
            mAssinar,
            MCertificate,
            MRecusa,
            MLoading
        },
        data() {
            return {
                signatureCertificate: false,
                fileStream: '',
                tokenTipo: 'E',
                request: {
                    arquivo: {},
                    required_document: false
                }
            }
        },
        mounted() {
            this.$refs.ModalLoading.open();
            this.$store.dispatch('getFileSignature', this.$route.params.id).then(response => {
                this.request = response;
                this.tokenTipo = response.token_tipo;
                if (this.request.assinado_em) {
                    this.viewSignatures();
                }
                this.$store.dispatch('getFile', response.fk_arquivo_id).then(response => {
                    this.fileStream = response;
                    setTimeout(() => {
                        this.$refs.ModalLoading.close();
                    }, 500);
                });
            }).catch(error => {
                console.log(error);
            });
        },
        beforeMount() {
            this.signWithoutCertificate = fileOperations.signWithoutCertificate.bind(this);
            this.signWithCertificatePublic = fileOperations.signWithCertificatePublic.bind(this);
            this.denyFile = fileOperations.denyFile.bind(this);
        },
        methods: {
            viewSignatures() {
                this.$router.push(`/validador?arquivo=${this.request.fk_arquivo_id}`);
            }
        }
    }
</script>

<style scoped>
    body {
        background-image: url("../../assets/email-pattern.png");
    }
</style>